export default __webpack_public_path__ + "static/media/ds03.5c91bf67.jpg";